import * as React from "react";
import { parse } from "query-string";
import { ItemPageProps } from "./debate-note-item-page";
import { OpinionEditorialModel } from "../model/autogen/OpinionEditorialModel"
import { withSnackbar } from "../components/with-snackbar";
import { withAuthContext } from "../components/with-auth-context";
import { UserLevel } from "../model/autogen/UserLevel";
import { OpinionEditorialsRequestFactory } from "../model/autogen/OpinionEditorialsController";
import { DocumentPublishModel } from "../model/autogen/DocumentPublishModel";
import { Content } from "../components/content";
import { DocumentMetadataDisplay } from "../components/document-metadata-display";
import { SanitisedHtml } from "../components/html";
import { TagList, Spacer } from "../components/utility-components";
import { OpinionEditorialEditRoute } from "../route-paths";
import Card from "@material-ui/core/Card/Card";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import * as moment from "moment";
import { FileAttachmentList } from "../components/file-attachment-list";
import { DocumentActionList } from "../components/document-action-list";

export function downloadLinkResolver(id: number) {
    return window.location.protocol + "//" + window.location.host + `/api/files/Download/${id}`;
}

export interface IOpinionEditorialPageState {
    model: OpinionEditorialModel | undefined;
}

class OpinionEditorialItemPageComponent extends React.Component<ItemPageProps, IOpinionEditorialPageState> {
    constructor(props: ItemPageProps) {
        super(props);
        this.state = { model: undefined };
    }
    private shouldIncludeDeleted(): boolean {
        const { includeDeleted } = parse(this.props.location.search);
        return this.props.user.level >= UserLevel.Editor && (!!includeDeleted == true);
    }

    public async componentDidMount() {
        this.loadContent();
    }

    private loadContent = async () => {
        const id = parseInt(this.props.match.params.id, 10);
        let model 
        try { 
            const result = await this.props.callApi((fetcher) => OpinionEditorialsRequestFactory.getById(fetcher,
                id, this.shouldIncludeDeleted()));
            if (result) {
                model = result
            }
        } catch (e) {
            window.location.href = '/page-not-found';
        } 
        this.setState({ model });
    }

    private onPublishContent = async (e: any) => {
        if (this.state.model && confirm("Are you sure you want to publish this content?")) {
            this.props.showSnackbarMessage("Publishing content ...");
            const payload = {
                documentId: this.state.model.id
            } as DocumentPublishModel;
            const model = await this.props.callApi((fetcher) => OpinionEditorialsRequestFactory.publish(fetcher, payload));
            this.props.showSnackbarMessage("Content published");
            window.location.href = '/data/unpublished';
            this.setState({ model });
        }
    }

    private onDelete = async (e: any) => {
        const { model } = this.state;
        if (model && confirm("Are you sure you want to archive this content?")) {
            this.props.showSnackbarMessage("Archiving content ...");
            try {
                const result = await this.props.callApi((fetcher) => OpinionEditorialsRequestFactory.delete(fetcher, model.id));
                if (result) {
                    this.props.showSnackbarMessage("Content archived");
                    this.props.history.goBack();
                }
            } catch (e) {
                this.props.showSnackbarMessage(`Failed to archive contnent: ${e}`);
            }
        }
    }
    private onBeginDeleteFile = (id: number) => {
        this.props.showSnackbarMessage("Deleting file")
    }
    private onFileDeleted = (id: number) => {
        const { model } = this.state;
        if (model) {
            model.files = model.files.filter(f => f.id != id);
            this.props.showSnackbarMessage("File deleted");
            this.setState({ model });
        }
    }
    public render() {
        const { model } = this.state;
        if (!model) {
            return <LinearProgress />;
        }

        return <Content>
            <h1>{model.title}</h1>
            <DocumentMetadataDisplay model={model} />
            <Card>
                <Content>
                    <article>
                        <h3>Date: {moment(model.dateField).format("ll")}</h3>
                        <h3>Summary</h3>
                        <SanitisedHtml html={model.summary} />
                        <h3>Body</h3>
                        <SanitisedHtml html={model.body} />
                    </article>
                    <Spacer/>
                    <FileAttachmentList files={model.files} downloadLinkResolver={downloadLinkResolver} editing={false} onBeginDeleteFile={this.onBeginDeleteFile} onFileDeleted={this.onFileDeleted} />
                    <Spacer/>
                    <TagList tags={model.tags} />
                </Content>
            </Card>
            <DocumentActionList editRoute={OpinionEditorialEditRoute(model.id)} model={model} user={this.props.user} onDelete={this.onDelete} onPublishContent={this.onPublishContent} />
        </Content>;
    }
}

export const OpinionEditorialItemPage = withSnackbar(withAuthContext(OpinionEditorialItemPageComponent) as any);


// WEBPACK FOOTER //
// ./src/pages/opinion-editorial-item-page.tsx